var unparam;

module.exports = unparam = function(str) {
  var data, i, keyPairs, keyVal, len, tuple;
  if (str == null) {
    str = location.search;
  }
  if (typeof str !== 'string') {
    throw new TypeError("unparam needs a string, but got " + (JSON.stringify(str)));
  }
  data = {};
  keyPairs = str.replace(/\+/g, '%20').split('&');
  for (i = 0, len = keyPairs.length; i < len; i++) {
    keyVal = keyPairs[i];
    if (!(tuple = /^\??([^=]*)=(.*)/.exec(keyVal))) {
      continue;
    }
    try {
      data[decodeURIComponent(tuple[1])] = decodeURIComponent(tuple[2]);
    } catch (error) {}
  }
  return data;
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2FyaWNodGVyL3JlcG9zaXRvcmllcy9zbHMvY29yZS9mcm9udGVuZC9ncm91cG9uX21vZHVsZXMvdW5wYXJhbS5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvVXNlcnMvYXJpY2h0ZXIvcmVwb3NpdG9yaWVzL3Nscy9jb3JlL2Zyb250ZW5kL2dyb3Vwb25fbW9kdWxlcy91bnBhcmFtLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDQSxJQUFBOztBQUFBLE1BQU0sQ0FBQyxPQUFQLEdBQWlCLE9BQUEsR0FBVSxTQUFDLEdBQUQ7QUFDekIsTUFBQTs7SUFEMEIsTUFBTSxRQUFRLENBQUM7O0VBQ3pDLElBQU8sT0FBTyxHQUFQLEtBQWMsUUFBckI7QUFDRSxVQUFVLElBQUEsU0FBQSxDQUFVLGtDQUFBLEdBQWtDLENBQUMsSUFBSSxDQUFDLFNBQUwsQ0FBZSxHQUFmLENBQUQsQ0FBNUMsRUFEWjs7RUFFQSxJQUFBLEdBQU87RUFFUCxRQUFBLEdBQVcsR0FBRyxDQUFDLE9BQUosQ0FBWSxLQUFaLEVBQW1CLEtBQW5CLENBQXlCLENBQUMsS0FBMUIsQ0FBZ0MsR0FBaEM7QUFDWCxPQUFBLDBDQUFBOztJQUNFLElBQUEsQ0FBZ0IsQ0FBQSxLQUFBLEdBQVEsa0JBQWtCLENBQUMsSUFBbkIsQ0FBd0IsTUFBeEIsQ0FBUixDQUFoQjtBQUFBLGVBQUE7O0FBQ0E7TUFBSSxJQUFLLENBQUEsa0JBQUEsQ0FBbUIsS0FBTSxDQUFBLENBQUEsQ0FBekIsQ0FBQSxDQUFMLEdBQW9DLGtCQUFBLENBQW1CLEtBQU0sQ0FBQSxDQUFBLENBQXpCLEVBQXhDO0tBQUE7QUFGRjtTQUdBO0FBVHlCIn0=
